import { render, staticRenderFns } from "./usecaseBox.vue?vue&type=template&id=3e092896&scoped=true&"
import script from "./usecaseBox.vue?vue&type=script&lang=js&"
export * from "./usecaseBox.vue?vue&type=script&lang=js&"
import style0 from "./usecaseBox.vue?vue&type=style&index=0&id=3e092896&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e092896",
  null
  
)

export default component.exports